import React from "react";
import { styled } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import { IMaskInput } from "react-imask";
import classes from "./InputAutocomplete.module.scss";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { FormHelperText } from "@mui/material";

const StyledTextField = styled(Autocomplete)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(2),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    backgroundColor: theme.palette.mode === "light" ? "#FFF" : "#FFF",
    borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    width: "100%",
    padding: "6px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    },
  },
}));

const MaskedTextField = React.forwardRef(function MaskedTextField(props, ref) {
  const { mask, maskOptions, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask={mask}
      inputRef={ref}
      {...maskOptions}
      onAccept={(value) => {
        if (props.onChange) {
          props.onChange({ target: { name: props.name, value } });
        }
      }}
      overwrite
    />
  );
});

const InputAutocomplete = (props) => {
  const {
    label = null,
    placeholder = null,
    required = false,
    error = null,
    classPrimary = null,
    errorText = "",
    onChange = null,
    onBlur = null,
    onKeyDown = null,
    name = null,
    mask = null,
    maskOptions = {},
    small = null,
    errorPrimary = null,
    ...inside_props 
  } = props;
  
  const errortext = errorText
  const showErrorComponent = <FormHelperText error ={error}>{errortext}</FormHelperText>;
  
  return (
    <>
      {(
        <FormControl
        error={error}
          variant="standard"
          className={
            small ? classes.FromControlFifty : classes.FromControlNormal
          }
        >
          <InputLabel
            required={required}
            style={{
              color: "#4D4D4D",
              fontWeight: "700"
            }}
            className={classes.InputLabel}
            shrink
            htmlFor={name}
          >
            {label}
          </InputLabel>
          <StyledTextField
            {...inside_props}
            onChange={(e) => {
              e.target.name=name
              onChange(e);
            }}
            onBlur={() => {
              console.log("Onblur");
              onBlur();
            }}
            onKeyDown={onKeyDown}
            name={name}
            placeholder={placeholder}
            id={name}
            variant="outlined"
            size="small"
            fullWidth
            className={classPrimary}
          />
          {error && showErrorComponent}
        </FormControl>
      )}
    </>
  );
};

export default InputAutocomplete;
